import { defineMessages } from "@formatjs/intl"
import type { FulfillmentCustomerTypeValues } from "./FulfillmentCustomerType"

export const fulfillmentCustomerTypeMessages = defineMessages<FulfillmentCustomerTypeValues>({
	END_CUSTOMER: {
		defaultMessage: "End Customer",
		id: "fulfillment.customerType.endCustomer",
	},
	KEY_ACCOUNT: {
		defaultMessage: "Key Account",
		id: "fulfillment.customerType.keyAccount",
	},
	RESELLER: {
		defaultMessage: "Reseller",
		id: "fulfillment.customerType.reseller",
	},
})
